import {axiosInstance} from './api';
import type {Paginated} from './types';

export interface ZoneWorkingHoursDto {
  id: string;
  zone: string;
  /** null = regular weekly schedule; "YYYY-MM-DD" = specific-date override */
  date: string | null;
  /** "HH:MM:SS" in the zone's local timezone; null on date override = closed that day */
  open_time: string | null;
  close_time: string | null;
  /** Bitmask: bit 0=Mon … bit 6=Sun. Ignored when date is set. */
  weekdays_mask: number;
  /** «Сотрудники должны приходить за N мин» для этой категории дней; null = дефолт зоны (#1324). */
  staff_arrival_minutes?: number | null;
}

export const listZoneWorkingHours = (zoneId: string) =>
  axiosInstance.get<Paginated<ZoneWorkingHoursDto>>(
    `/core/api/zone-working-hours/?zone=${zoneId}&page_size=1000`,
  );

export const createZoneWorkingHours = (payload: Omit<ZoneWorkingHoursDto, 'id'>) =>
  axiosInstance.post<ZoneWorkingHoursDto>('/core/api/zone-working-hours/', payload);

export const updateZoneWorkingHours = (id: string, payload: Partial<Omit<ZoneWorkingHoursDto, 'id'>>) =>
  axiosInstance.patch<ZoneWorkingHoursDto>(`/core/api/zone-working-hours/${id}/`, payload);

export const deleteZoneWorkingHours = (id: string) =>
  axiosInstance.delete(`/core/api/zone-working-hours/${id}/`);
